import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * /scan-me — formerly hard-redirected to a one-off Raipur Zoho event URL
 * that is now dead. Until a live event is configured, send users to the
 * Events & Webinars page instead of a broken external link.
 *
 * To point this at a live event again, set EVENT_URL to the external URL.
 */
const EVENT_URL = ""; // e.g. "https://events.cloudare.in/your-live-event"

const Event = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (EVENT_URL) {
      window.location.href = EVENT_URL;
    } else {
      navigate("/EventAndWebinars", { replace: true });
    }
  }, [navigate]);

  return null;
};

export default Event;
